import { CompanyStatuses } from '@components/business/companyStatuses/CompanyStatuses'
import Page from '@components/Page/Page'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { CompanyStatus as CompanyStatusModel } from '@models/business/CompanyStatus'
import {
  getCompanyStatuses,
  selectCompanyStatuses,
  setCompanyStatusQuery,
} from '@store/business/CompanyStatusReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { useEffect } from 'react'

const CompanyStatusesPage = () => {
  const { isOpen } = useSBRM()

  const dispatch = useAppDispatch()
  const companyStatuses = useAppSelector(selectCompanyStatuses())
  const { query, isLoading } = useAppSelector((state) => state.companyStatus)

  const columns: TableColumnsType<CompanyStatusModel> = [
    {
      title: 'Avatar',
      render: (record: CompanyStatusModel) => (
        <CompanyStatuses.StatusTag model={record} />
      ),
    },
    {
      align: 'right',
      render: (record: CompanyStatusModel) => (
        <SBRM.Actions
          actions={[SBRMAction.Update, SBRMAction.Delete]}
          entity={Entity.companyStatus}
          entityId={record.id}
          bypassHasAccessCheck
        />
      ),
    },
  ]

  const fetchCompanyStatuses = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }

    dispatch(setCompanyStatusQuery(newQuery))
    dispatch(getCompanyStatuses(newQuery))
  }

  const { handleTableChange, params } = useTableUrlSync<CompanyStatusModel>({
    onParamsChange: fetchCompanyStatuses,
  })

  useEffect(() => {
    if (isOpen) return

    fetchCompanyStatuses(params)
  }, [isOpen])

  return (
    <Page
      permissions={Permission.manageBusiness}
      pageTitle={{
        title: 'Company statuses',
        level: 4,
        toolbar: (
          <SBRM.Actions
            actions={[SBRMAction.Create]}
            entity={Entity.companyStatus}
            bypassHasAccessCheck
          />
        ),
      }}
    >
      <SBTable
        columns={columns}
        dataSource={companyStatuses}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
      />
    </Page>
  )
}

export default CompanyStatusesPage
